import { Auth0Provider } from '@auth0/auth0-react';
import type { Auth0ProviderOptions } from '@auth0/auth0-react/dist/auth0-provider';
import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { auth0ProviderOptions } from '../config/app';

const Auth0ProviderWithNavigate = ({ children }: any): ReactElement => {
  const navigate = useNavigate();

  const authOptions: Auth0ProviderOptions = {
    ...auth0ProviderOptions(),
    authorizationParams: {
      audience: 'https://www.idexx.com/myidexx',
      redirect_uri: `${location.origin}/callback`,
    },
    onRedirectCallback: () => void navigate('/', { replace: true }),
  };

  return <Auth0Provider {...authOptions}>{children}</Auth0Provider>;
};

export default Auth0ProviderWithNavigate;
